module.exports = __webpack_public_path__ + "images/0b708f141e531a93292c23845554bc3c.webp";